/* Duendes Air — filtro por intención (client-side) en la grilla de colección (L3).
   Mapea el chip → palabras clave en data-energia (metafield ddu.energia). */
(function () {
  if (window.__airCat) return; window.__airCat = 1;
  function boot() {
    var root = document.querySelector('[data-air-collection]');
    if (!root) return;
    var chips = root.querySelectorAll('[data-fchip]');
    var cards = root.querySelectorAll('[data-energia]');
    var empty = root.querySelector('[data-air-empty]');
    var map = { 'Protección': 'protec', 'Abundancia': 'abundancia|dinero', 'Amor': 'amor', 'Sanación': 'sanaci', 'Suerte': 'suerte', 'Calma': 'calma|ansiedad|paz' };
    var active = null;
    function apply() {
      var shown = 0;
      cards.forEach(function (c) {
        var e = (c.getAttribute('data-energia') || '');
        var ok = true;
        if (active && map[active]) { ok = map[active].split('|').some(function (k) { return e.indexOf(k) > -1; }); }
        c.style.display = ok ? '' : 'none';
        if (ok) shown++;
      });
      if (empty) empty.style.display = shown ? 'none' : '';
    }
    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        var v = ch.getAttribute('data-fchip');
        if (v === '*' || active === v) { active = null; } else { active = v; }
        chips.forEach(function (x) {
          var xv = x.getAttribute('data-fchip');
          x.classList.toggle('is-on', (xv === '*' && !active) || (xv === active));
        });
        apply();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();